import { render, staticRenderFns } from "./QueryUmaoi.vue?vue&type=template&id=52f5dbf8&scoped=true&"
import script from "./QueryUmaoi.vue?vue&type=script&lang=js&"
export * from "./QueryUmaoi.vue?vue&type=script&lang=js&"
import style0 from "./QueryUmaoi.vue?vue&type=style&index=0&id=52f5dbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5dbf8",
  null
  
)

export default component.exports